//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ReviewSharingOption } from './Enums';

export class ReviewInputItem extends ItemBase {
    TeacherID: string | null = null;
    ParentID: string | null = null;
    RatingPercentage: number = 0;
    ReviewBody: string | null = null;
    SharingOption: ReviewSharingOption = ReviewSharingOption.AdminOnly;

    constructor(initializer?: Partial<ReviewInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ReviewInputItem";
}
